<template>
	<nk-page :commercialAccess="['Sale', 'Warehouse']" :policyClaims="['Product_ProductPriceLevel_Management']">
		<template #badges>
			<nk-badge system="sale"></nk-badge>
		</template>
		<nk-table v-model="selectedRow" @data-changed="dataChanged" :data="productPrices" :options="tableOptions" ref="productPriceLevel" tabindex="101" startup @row_dbClicked="rowDbClicked" class="nk-card">
		</nk-table>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import Input from '~/components/general/nikan-input.vue'
	import $sc from '~/plugins/shortcut.collection'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import validators from '~/statics/validators'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import emptyId from '~/statics/empty-id'
	import { mapActions, mapGetters } from 'vuex'

	export default {
		modal: {
			size: 'md',
			stateUID: 'product-price-level',
			helpTag: 'ProductPriceLevel'
		},
		props: {
			options: { type: Object },
			data: { type: Object },
		},
		data() {
			return {
				localSelectedItem: null,
				selectedRow: null,
				settings: {
					selectable: false
				},
				tableOptions: {
					activeRowDisabled: true,
					editable: this.$nikan.checkPermission('Product_ProductPriceLevel_Edit'),
					searchable: false,
					allowNewRow: true,
					alwaysEmit: true,
					buttons: {
						addBtn: {
							options: {
								visible: true,
								policyClaims: 'Product_ProductPriceLevel_Edit',
							}
						},
						deleteBtn: {
							options: {
								visible: true,
								policyClaims: 'Product_ProductPriceLevel_Edit',
							}
						}
					},
					prepareNewRow: () => {
						return {
							companyId: emptyId,
							name: '',
						}
					},
					columns: [
						{
							name: 'rowNumber',
							title: this.$t('row-number'),
							searchable: true,
							sortable: true,
							editable: false,
							entering: false,
							pinned: true,
							pinnable: false,
							resizable: false,
							width: '10%',
						},
						{
							name: 'name',
							title: this.$t('sale.product-priceLevel.f.name'),
							edit: {
								component: Input,
								options: {
									mode: 'string',
								},
							},
							align: 'center',
							searchable: true,
							sortable: false,
							editable: true,
							validators: validators('required'),
							width: '90%',
						},
					],
				},
				pageButtons: {
					selectButton: {
						title: this.$t('select'),
						shortcut: $sc.find('enter-only'),
						element: () => this.$refs.productPriceLevel.$el,
						icon: 'check',
						isPrimary: true,
						visible: (this.options || {}).selectable,
						disabled: false,
						handle: (button, page, e) => {
							if (_.isEmpty(this.selectedRow))
								return this.$toast(this.$t('document.m.select-row'))

							this.resolve(this.selectedRow)
						}
					},
					saveButton: {
						title: this.$t('save-changes'),
						shortcut: $sc.find('save'),
						visible: true,
						disabled: true,
						icon: 'save',
						handle: (button, page, e) => {
							this.save().then((res) => {
								this.$nikan.formUtility.switchMode(this.pageButtons, 'select')
								this.$refs.productPriceLevel.table_Focused()
							})
						},
						policyClaims: 'Product_ProductPriceLevel_Edit',
					},
				}
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
				},
			},
		},
		created() {
			this.localSelectedItem = this.data
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)

			let buttonsArray
			if (this.grandParentType() === 'modal') {
				buttonsArray = [this.pageButtons.selectButton, this.pageButtons.saveButton]
			} else {
				this.pageButtons.selectButton.visible = false
				buttonsArray = [this.pageButtons.saveButton]
			}

			this.prepareWindow(this.$t('sale.product-priceLevel.title'), buttonsArray)

			this.refreshProductPriceLevels()
		},
		computed: {
			...mapGetters({
				all: 'productPriceLevels/all'
			}),
			productPrices() {
				return this.all
			}
		},
		methods: {
			...mapActions({
				refreshProductPriceLevels: 'productPriceLevels/refresh',
				broadcastRefresh: 'socket/broadcastRefresh'
			}),
			dataChanged() {
				this.$nikan.formUtility.switchMode(this.pageButtons, 'edit')
			},
			save() {
				return new Promise((resolve, reject) => {
					this.$refs.productPriceLevel
						.commitChanges()
						.then((productPrices) => {
							var data = {
								Items: productPrices,
							}

							post(Endpoints.getUrl('sale.product.price.level.modify'), data)
								.then((result) => {
									this.broadcastRefresh('ProductPriceLevels')
									resolve(this.productPrices)
									this.$toast(this.$t('sale.product-priceLevel.m.save.success'), { type: 'success' })
								})
								.catch(() => {
									this.defer(() => this.$refs.productPriceLevel.$el.focus(), 1)
								})
						})
						.catch((errorRows) => {
							if (Array.isArray(errorRows)) {
								var rowNumbers = errorRows.map((x, i) => x.rowNumber).join(',')
								dialog({
									title: this.$t('sale.product-priceLevel.m.save-priceLevel-title'),
									body: this.$t('sale.product-priceLevel.m.save.error.rows', {
										rowNumbers,
									}),
									type: 'error',
								})
							} else {
								dialog({
									title: this.$t('sale.product-priceLevel.m.save-priceLevel-title'),
									body: errorRows.message,
									type: 'error',
								})
							}

							reject(new Error('invalid-rows'))
							this.defer(() => this.$refs.productPriceLevel.$el.focus(), 100)
						})
				})
			},
			rowDbClicked(val) {
				if (this.grandParentType() === 'modal')
					this.resolve(val)
			}
		},
	}
</script>
<style></style>
